import { FaLinkedin } from "react-icons/fa"
import {AiOutlineTwitter} from 'react-icons/ai'
import { FaFacebook } from "react-icons/fa";
import {AiFillGithub} from 'react-icons/ai'

const data = [
    {id: 1, link: 'https://www.linkedin.com/in/tafitasoa-nomena-randriamampianina-71b66b245/', icon: <FaLinkedin/>},
    {id: 2, link: 'https://twitter.com/NomenaTafitaRR', icon: <AiOutlineTwitter/>},
    {id: 3, link: 'https://web.facebook.com/nomenatafitasoa.randriamampianina', icon: <FaFacebook/>},
    {id: 4, link: 'https://github.com/TafitasoaNooms27', icon: <AiFillGithub/>}
]

export default data